import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { axios } from '@/library/axios';
import { queryClient } from '@/library/react-query';
import type { BaseResponse } from '@/types';
import { displayError } from '@/utils/functions/displayError';

import type { AddBankReq, CustomerBanks } from './types';

const addCustomerBank = async (data: {
  customerId: string;
  payload: AddBankReq;
}): Promise<CustomerBanks> => {
  const res = await axios<
    CustomerBanks,
    BaseResponse<CustomerBanks>,
    AddBankReq
  >({
    url: `/ucic/customers/${data.customerId}/banks`,
    method: 'post',
    data: data.payload,
  });

  return res?.data?.data;
};

export const useAddCustomerBank = () => {
  const { mutateAsync, isLoading, error } = useMutation(addCustomerBank, {
    onSuccess: () => {
      queryClient.invalidateQueries('bank-details');
    },
  });

  useEffect(() => {
    displayError(error);
  }, [error]);

  return { addCustomerBank: mutateAsync, isLoading };
};
